import { useState } from "react";
import { ModuleHeader } from "./VideoCarousel";

const BEADS = 108;

// A gentle interactive japa counter — tap the bead 108 times for one round.
export const MalaCounter = ({ module }) => {
  const [count, setCount] = useState(0);
  const done = count >= BEADS;
  const pct = Math.min(count / BEADS, 1);
  return (
    <div data-testid={`journey-mala-${module.id}`} className="mx-auto max-w-xl px-5 text-center">
      <ModuleHeader title={module.title} subtitle={module.subtitle} />
      <div className="mt-10 grid place-items-center">
        <button
          data-testid="mala-bead"
          onClick={() => setCount((c) => Math.min(c + 1, BEADS))}
          className="relative grid h-40 w-40 place-items-center rounded-full bg-gradient-to-br from-amber-400 to-amber-600 text-[#0a0f24] shadow-[0_0_50px_rgba(251,191,36,0.35)] transition-transform active:scale-95"
        >
          <span className="font-display text-5xl">{count}</span>
          <span className="absolute bottom-7 text-xs font-semibold uppercase tracking-wider opacity-70">
            / {BEADS}
          </span>
        </button>
        <div className="mt-6 h-1.5 w-56 overflow-hidden rounded-full bg-white/10">
          <div
            className="h-full bg-gradient-to-r from-amber-300 to-amber-500 transition-all"
            style={{ width: `${pct * 100}%` }}
          />
        </div>
        <p className="mt-4 text-sm text-amber-50/60" data-testid="mala-status">
          {done ? "One round complete — Hare Krishna!" : "Tap the bead and chant along."}
        </p>
        {count > 0 && (
          <button
            onClick={() => setCount(0)}
            className="mt-3 text-xs text-amber-300/70 underline-offset-4 hover:underline"
          >
            Reset
          </button>
        )}
      </div>
    </div>
  );
};
